import GuideComponent from 'components/guideToAddProduct';
import Header from 'modules/header/farm/main';

const Guide = () => {
  return (
    <>
      <Header title="راهنمای انتخاب فروش محصول " />
      <GuideComponent app="farm" />
    </>
  );
};

export default Guide;
